import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QRScannerCard = ({ onScanComplete }) => {
  const [isScanning, setIsScanning] = useState(false);
  const [scanHistory, setScanHistory] = useState([
  {
    id: 1,
    businessName: "Café Aroma Colombiano",
    businessLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_1250e85be-1766879481924.png",
    businessLogoAlt: "Café Aroma Colombiano logo showing steaming coffee cup with Colombian flag colors in modern minimalist design",
    discount: "15%",
    scannedAt: new Date(Date.now() - 3600000),
    address: "Calle 18 #25-40, Pasto"
  },
  {
    id: 2,
    businessName: "Restaurante El Sabor Nariñense",
    businessLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_13c6b4c27-1766879481915.png",
    businessLogoAlt: "Restaurante El Sabor Nariñense logo featuring traditional Colombian food plate with colorful ingredients on rustic wooden background",
    discount: "20%",
    scannedAt: new Date(Date.now() - 7200000),
    address: "Carrera 27 #15-32, Pasto"
  },
  {
    id: 3,
    businessName: "Boutique Moda Elegante",
    businessLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_1e85f4302-1766879480679.png",
    businessLogoAlt: "Boutique Moda Elegante logo displaying elegant fashion mannequin in designer clothing with modern retail store interior background",
    discount: "25%",
    scannedAt: new Date(Date.now() - 86400000),
    address: "Calle 20 #30-15, Pasto"
  }]
  );

  const handleStartScan = () => {
    setIsScanning(true);
    setTimeout(() => {
      setIsScanning(false);
      if (onScanComplete) {
        onScanComplete({
          businessName: "Nuevo Negocio",
          discount: "10%"
        });
      }
    }, 3000);
  };

  const formatTimeAgo = (date) => {
    const seconds = Math.floor((new Date() - date) / 1000);
    if (seconds < 3600) return `Hace ${Math.floor(seconds / 60)} minutos`;
    if (seconds < 86400) return `Hace ${Math.floor(seconds / 3600)} horas`;
    return `Hace ${Math.floor(seconds / 86400)} días`;
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-card">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary/10">
            <Icon name="QrCode" size={24} color="var(--color-primary)" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-foreground">Escáner QR</h2>
            <p className="text-sm text-muted-foreground">Escanea códigos de negocios</p>
          </div>
        </div>
        <Button
          variant={isScanning ? "destructive" : "default"}
          onClick={handleStartScan}
          disabled={isScanning}
          iconName={isScanning ? "X" : "Camera"}
          iconPosition="left">

          {isScanning ? "Cancelar" : "Activar Cámara"}
        </Button>
      </div>
      {isScanning &&
      <div className="mb-6 p-8 bg-muted rounded-lg border-2 border-dashed border-border flex flex-col items-center justify-center">
          <div className="w-48 h-48 bg-background rounded-lg flex items-center justify-center mb-4 relative overflow-hidden">
            <div className="absolute inset-0 border-4 border-primary animate-pulse"></div>
            <Icon name="QrCode" size={96} color="var(--color-primary)" className="opacity-50" />
          </div>
          <p className="text-sm font-medium text-foreground mb-2">Escaneando código QR...</p>
          <p className="text-xs text-muted-foreground text-center">Apunta la cámara al código QR del negocio</p>
        </div>
      }
      <div>
        <h3 className="text-sm font-semibold text-foreground mb-4 flex items-center gap-2">
          <Icon name="History" size={16} />
          Historial de Escaneos
        </h3>
        <div className="space-y-3">
          {scanHistory?.map((scan) =>
          <div
            key={scan?.id}
            className="flex items-center gap-4 p-3 bg-muted rounded-lg hover:bg-muted/80 transition-colors">

              <div className="w-12 h-12 rounded-lg overflow-hidden flex-shrink-0 bg-background">
                <img
                src={scan?.businessLogo}
                alt={scan?.businessLogoAlt}
                className="w-full h-full object-cover"
                onError={(e) => {e.target.src = '/assets/images/no_image.png';}} />

              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground truncate">{scan?.businessName}</p>
                <p className="text-xs text-muted-foreground truncate">{scan?.address}</p>
              </div>
              <div className="flex items-center gap-3 flex-shrink-0">
                <div className="px-3 py-1 bg-success/10 rounded-full">
                  <span className="text-sm font-bold text-success">{scan?.discount}</span>
                </div>
                <p className="text-xs text-muted-foreground whitespace-nowrap">{formatTimeAgo(scan?.scannedAt)}</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>);

};

export default QRScannerCard;